import TableInformations from "./TableInformations";
import ItemDescription from "./ItemDescription";
import useMediaBreakpoints from "hooks/useMediaBreakpoints";
import Card from "Components/card/Card";
import { Inquiries } from "Components/list";
import { useItemContext } from "..";
import Reviews from "Components/list/Reviews";
import { REPORT_TYPE } from "constants/data";
import FarmContact from "Components/sections/FarmContact";
import { BuyerBanners } from "Pages/home/components";
import {Fragment} from 'react'

export interface IItemDetailsProps {}

export default function ItemDetails(props: IItemDetailsProps) {
  const { data } = useItemContext();

  const { downTabletBreakpoint: isMobile } = useMediaBreakpoints();
  const { companyData } = useItemContext();

  return (
    <Fragment>
      <Card>
        <TableInformations />

        <ItemDescription />
      </Card>

      {/* User reviews */}
      <Reviews
        type={REPORT_TYPE.supplier}
        title={data?.farm_item_name}
        reference_name={data?.farm}
      />

      {/* Sent inquiries */}
      <Inquiries farm_item={data.name} />

      {/* {isMobile && <ContactSupplierCard className="card" mt={2} />} */}
      {isMobile && <FarmContact supplierId={companyData?.name}/>}
      {isMobile && <BuyerBanners positionBanner="right-detail" isNotRandom marginTop="16px" rightBanner/>}
    </Fragment>
  );
}
